module.exports = __webpack_public_path__ + "static/media/lalogo.d03e8897.png";